import { useStore, plannerConfig } from '../lib/store.ts'
import { projectSchedule } from '../lib/planner.ts'
import { addDays, dayKey, daysBetween, fromDayKey, humanDays } from '../lib/time.ts'
import { Bar } from '../components/ui.tsx'

const WEEKDAYS = ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']

export function PlanScreen() {
  const { idx, settings, session, now, cards } = useStore()
  const cfg = plannerConfig(settings)
  const start = fromDayKey(settings.startedAt)
  const plans = projectSchedule(
    idx.order,
    (pid) => idx.moduleOfPhrase.get(pid) ?? '',
    start,
    cfg,
    (offset) => dayKey(addDays(start, offset)),
  )
  const todayKey = dayKey(now)
  const introduced = idx.order.filter((id) => (cards.get(id)?.state ?? 'new') !== 'new').length

  return (
    <div className="screen stack">
      <h1 style={{ paddingTop: 8 }}>План до 9 листопада</h1>

      <div className="card stack--tight stack">
        <div className="row row--between">
          <strong>Курс загалом</strong>
          <span className="muted small">
            {Number.isFinite(session.daysLeft) ? humanDays(session.daysLeft) : '—'}
          </span>
        </div>
        <Bar value={introduced} max={idx.order.length} />
        <div className="tiny faint">
          {introduced} з {idx.order.length} фраз · {session.newPerDay} нових на день ·
          останні {cfg.finalStretchDays} днів — тільки повторення
        </div>
      </div>

      <div className="card">
        <p className="small muted">
          План перераховується щодня. Пропустив день — норма трохи підросте,
          а не накопичиться боргом. Останні девʼять днів нового матеріалу немає:
          це прогін усього вивченого перед поїздкою.
        </p>
      </div>

      <div className="list">
        {plans.map((p) => {
          const isToday = p.dateKey === todayKey
          const isPast = daysBetween(fromDayKey(p.dateKey), now) > 0
          const mods = p.moduleIds.map((id) => idx.moduleById.get(id)).filter(Boolean)
          const date = new Date(fromDayKey(p.dateKey))
          return (
            <div
              className="item"
              key={p.dateKey}
              style={{
                opacity: isPast ? 0.45 : 1,
                borderColor: isToday ? 'var(--accent)' : undefined,
              }}
            >
              <span className="item__emoji" aria-hidden style={{ fontSize: 15, width: 34, textAlign: 'center' }}>
                <span style={{ display: 'block', fontWeight: 700 }}>{date.getDate()}</span>
                <span className="tiny faint">{WEEKDAYS[date.getDay()]}</span>
              </span>
              <span className="item__body">
                <span className="item__title">
                  {p.mode === 'exam' ? '🎓 Екзамен-симуляція'
                    : p.mode === 'final' ? 'Прогін вивченого'
                    : mods.map((m) => `${m!.emoji} ${m!.title}`).join(' · ') || 'Повторення'}
                </span>
                <span className="item__sub">
                  {p.newCount > 0 ? `${p.newCount} нових фраз` : 'без нового матеріалу'}
                  {isToday && ' · сьогодні'}
                </span>
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
